import { observer } from 'mobx-react-lite';
import { StyleProp } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { IUserImageAreaModel } from 'src/store/_models/userImageArea';
import { useResponsiveScale } from '../../contexts/ResponsiveScaleContext';
import { getUserImageAreaTestID } from './UserImageArea.utils';
import { ViewStyle } from 'react-native';

export type UserImageAreaProps = {
  userImageArea: IUserImageAreaModel;
  children?: React.ReactNode;
  isSelected?: boolean;
  lessVisibleIfNotSelected?: boolean;
  ignoreOffsets?: boolean;
  placeholderInfo?: string;
  style?: StyleProp<ViewStyle>;
};

export const UserImageArea = observer(
  ({
    userImageArea,
    isSelected = false,
    children,
    lessVisibleIfNotSelected = false,
    ignoreOffsets = false,
    placeholderInfo,
    style,
  }: UserImageAreaProps) => {
    const { responsiveScaleSV, responsiveScale } = useResponsiveScale();

    const animatedStyle = useAnimatedStyle(
      () => ({
        position: ignoreOffsets ? 'relative' : 'absolute',
        left: ignoreOffsets ? 0 : userImageArea.x * responsiveScaleSV.value,
        top: ignoreOffsets ? 0 : userImageArea.y * responsiveScaleSV.value,
        width: userImageArea.width * responsiveScaleSV.value,
        height: userImageArea.height * responsiveScaleSV.value,
        zIndex: isSelected ? 1 : 0,
        opacity: lessVisibleIfNotSelected && !isSelected ? 0.5 : 1,
      }),
      [
        responsiveScaleSV,
        userImageArea.height,
        userImageArea.width,
        userImageArea.x,
        userImageArea.y,
        isSelected,
        lessVisibleIfNotSelected,
        responsiveScale,
      ],
    );

    return (
      <Animated.View
        key={`UserImageArea-${userImageArea.id}`}
        testID={getUserImageAreaTestID(userImageArea, placeholderInfo)}
        style={[style, animatedStyle]}
      >
        {children}
      </Animated.View>
    );
  },
);
